function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient",
  x1: 509,
  y1: -1423.77,
  x2: 572.04,
  y2: -1595.24,
  gradientTransform: "matrix(1 0 0 -1 0 -1233.93)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#5c71b3",
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-2",
  x1: 522.58,
  y1: 1270.02,
  x2: 547.68,
  y2: 1306.93,
  gradientTransform: "translate(29.44 -969.45)",
  xlinkHref: "#slack_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-3",
  x1: 679.87,
  y1: 1276.77,
  x2: 687.25,
  y2: 1299.2,
  gradientTransform: "translate(-68.2 -969.45)",
  xlinkHref: "#slack_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-4",
  x1: 414.8,
  y1: 1046.67,
  x2: 501.75,
  y2: 1295.94,
  gradientTransform: "matrix(-1 0 0 1 1028.74 -969.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#014955"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.11,
  stopColor: "#215b5c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#7a8e71"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#bbb481"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#e4cb8a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f3d48e"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-5",
  x1: 450.86,
  y1: 1072.88,
  x2: 460.04,
  y2: 1120.38,
  gradientTransform: "matrix(-1 0 0 1 1028.74 -969.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#101436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.64,
  stopColor: "#27335c",
  stopOpacity: 0.35
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#31406b",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-6",
  x1: 478.14,
  y1: 1086.75,
  x2: 439.15,
  y2: 1061.34,
  gradientTransform: "matrix(-1 0 0 1 1028.74 -969.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#b1bcdf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-7",
  x1: 477.35,
  y1: 1082.12,
  x2: 420.39,
  y2: 1102.73,
  gradientTransform: "matrix(-1 0 0 1 1028.74 -969.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#94a2d2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#aab5db"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.21,
  stopColor: "#bbc4e3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#c6cee8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#cdd4eb"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-8",
  x1: 509.16,
  y1: 1047.17,
  x2: 426.89,
  y2: 1076.94,
  xlinkHref: "#slack_svg__linear-gradient-7"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-9",
  x1: 286.99,
  y1: -1578.66,
  x2: 353,
  y2: -1758.22,
  xlinkHref: "#slack_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-10",
  x1: 56.01,
  y1: -1581.4,
  x2: 404.15,
  y2: -1581.4,
  gradientTransform: "matrix(1 0 0 -1 0 -1233.93)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f2f5fa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-11",
  x1: -107.95,
  y1: -1534.9,
  x2: 158.17,
  y2: -1511.8,
  xlinkHref: "#slack_svg__linear-gradient-10"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-12",
  x1: 1.38,
  y1: -1558.71,
  x2: 315.47,
  y2: -1558.71,
  gradientTransform: "matrix(1 0 0 -1 0 -1233.93)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-13",
  x1: 35.54,
  y1: -1596.49,
  x2: 113.49,
  y2: -1595.81,
  gradientTransform: "matrix(1 0 0 -1 0 -1233.93)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-14",
  x1: 82.02,
  y1: -1517.17,
  x2: 378.11,
  y2: -1517.17,
  xlinkHref: "#slack_svg__linear-gradient-10"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-15",
  x1: 84.29,
  y1: -1350.1,
  x2: 365.07,
  y2: -1718.67,
  gradientTransform: "matrix(1 0 0 -1 0 -1233.93)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-16",
  x1: 1.38,
  y1: -1494.35,
  x2: 315.47,
  y2: -1494.35,
  xlinkHref: "#slack_svg__linear-gradient-12"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-17",
  x1: 35.54,
  y1: -1532.13,
  x2: 113.49,
  y2: -1531.45,
  xlinkHref: "#slack_svg__linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-18",
  x1: 264.78,
  y1: -1618.7,
  x2: 223.83,
  y2: -1431.22,
  gradientTransform: "matrix(1 0 0 -1 0 -1233.93)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.13,
  stopColor: "#7991bd"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#396a85"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.84,
  stopColor: "#105262"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#014955"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-19",
  x1: 254.29,
  y1: -1521.22,
  x2: 185.1,
  y2: -1361.21,
  gradientTransform: "matrix(1 0 0 -1 0 -1233.93)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#5c71b3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f7c963"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-20",
  x1: 181.2,
  y1: -1418.56,
  x2: 201.49,
  y2: -1390.15,
  gradientTransform: "matrix(1 0 0 -1 0 -1233.93)",
  xlinkHref: "#slack_svg__linear-gradient-5"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-21",
  x1: 235.76,
  y1: -1632.37,
  x2: 194.81,
  y2: -1444.89,
  xlinkHref: "#slack_svg__linear-gradient-18"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-22",
  x1: 201.8,
  y1: -1453.76,
  x2: 131.36,
  y2: -1497.02,
  gradientTransform: "matrix(1 0 0 -1 0 -1233.93)",
  xlinkHref: "#slack_svg__linear-gradient-5"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-23",
  x1: 221.01,
  y1: -1438.35,
  x2: 215.28,
  y2: -1512.84,
  gradientTransform: "matrix(1 0 0 -1 0 -1233.93)",
  xlinkHref: "#slack_svg__linear-gradient-5"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-24",
  x1: 214.25,
  y1: -1469.19,
  x2: 191.42,
  y2: -1469.19,
  gradientTransform: "matrix(1 0 0 -1 0 -1233.93)",
  xlinkHref: "#slack_svg__linear-gradient-7"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-25",
  x1: 226.56,
  y1: -1533.22,
  x2: 157.36,
  y2: -1373.2,
  xlinkHref: "#slack_svg__linear-gradient-19"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-26",
  x1: 187.2,
  y1: -1394.49,
  x2: 178.03,
  y2: -1455.4,
  gradientTransform: "matrix(1 0 0 -1 0 -1233.93)",
  xlinkHref: "#slack_svg__linear-gradient-5"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-27",
  x1: 219,
  y1: -1536.48,
  x2: 149.81,
  y2: -1376.47,
  xlinkHref: "#slack_svg__linear-gradient-19"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-28",
  x1: 307.01,
  y1: -1417.73,
  x2: 143.1,
  y2: -1477.05,
  gradientTransform: "matrix(1 0 0 -1 0 -1233.93)",
  xlinkHref: "#slack_svg__linear-gradient-7"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-29",
  x1: 212.18,
  y1: -1404.57,
  x2: 233.1,
  y2: -1435.06,
  xlinkHref: "#slack_svg__linear-gradient-15"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-30",
  x1: 893.84,
  y1: 1016.49,
  x2: 1081.63,
  y2: 1173.42,
  gradientTransform: "matrix(-1 0 0 1 1441.13 -969.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f2f5fa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#f0f3f9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.39,
  stopColor: "#e9edf7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46,
  stopColor: "#dee3f2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#d3daee"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.61,
  stopColor: "#cdd5eb"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#bcc6e4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.91,
  stopColor: "#a0add7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8e9dcf"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-31",
  x1: 767.31,
  y1: 1125.4,
  x2: 923.67,
  y2: 1113.5,
  gradientTransform: "matrix(-1 0 0 1 1441.13 -969.45)",
  xlinkHref: "#slack_svg__linear-gradient-15"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-32",
  x1: -2669.07,
  y1: 1105.65,
  x2: -2560.61,
  y2: 1105.65,
  gradientTransform: "translate(3074.26 -969.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.09,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-33",
  x1: -521.55,
  y1: 1141.15,
  x2: -565.74,
  y2: 1148.17,
  gradientTransform: "rotate(10.39 6093.15 6344.699)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#313866"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#535a8b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "#7980b3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#878ec2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-34",
  x1: -797.14,
  y1: 1062.85,
  x2: -834.2,
  y2: 1055.98,
  gradientTransform: "translate(1306.78 -969.45)",
  xlinkHref: "#slack_svg__linear-gradient-33"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-35",
  x1: -773.02,
  y1: 1039.56,
  x2: -856.33,
  y2: 1052.8,
  gradientTransform: "translate(1306.78 -969.45)",
  xlinkHref: "#slack_svg__linear-gradient-33"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-36",
  x1: -808.82,
  y1: 1004.93,
  x2: -850.73,
  y2: 968.85,
  gradientTransform: "translate(1306.78 -969.45)",
  xlinkHref: "#slack_svg__linear-gradient-33"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-37",
  x1: -799.6,
  y1: 1026.18,
  x2: -775.97,
  y2: 967.95,
  gradientTransform: "translate(1306.78 -969.45)",
  xlinkHref: "#slack_svg__linear-gradient-33"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-38",
  x1: -769.44,
  y1: 1069,
  x2: -841.28,
  y2: 1080.41,
  gradientTransform: "translate(1306.78 -969.45)",
  xlinkHref: "#slack_svg__linear-gradient-33"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-39",
  x1: -777.62,
  y1: 1010.41,
  x2: -860.97,
  y2: 1023.66,
  gradientTransform: "translate(1306.78 -969.45)",
  xlinkHref: "#slack_svg__linear-gradient-33"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-40",
  x1: -1354.77,
  y1: 318.59,
  x2: -1331.14,
  y2: 260.36,
  gradientTransform: "rotate(-6.28 -2726.893 -16934.806)",
  xlinkHref: "#slack_svg__linear-gradient-33"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-41",
  x1: -1480.73,
  y1: -2883.66,
  x2: -1494.77,
  y2: -2910.6,
  gradientTransform: "matrix(-1 -.06 -.06 1 -1130.66 2828.69)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#313866"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#313866",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-42",
  x1: 2081.89,
  y1: -3306.78,
  x2: 2099.02,
  y2: -3306.78,
  gradientTransform: "matrix(-.89 .01 .06 .99 764.17 3313.78)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#313866",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#313866",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-43",
  x1: 2081.89,
  y1: -3304.61,
  x2: 2099.02,
  y2: -3304.61,
  xlinkHref: "#slack_svg__linear-gradient-42"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "slack_svg__linear-gradient-44",
  x1: 2081.89,
  y1: -3307.48,
  x2: 2099.02,
  y2: -3307.48,
  xlinkHref: "#slack_svg__linear-gradient-42"
}), /*#__PURE__*/React.createElement("style", null, ".slack_svg__cls-4{fill:#bf7b43}.slack_svg__cls-5{fill:#faac18}.slack_svg__cls-8{fill:#2d327e}.slack_svg__cls-9{fill:#f2f5fa}.slack_svg__cls-10{fill:#8e5b35}.slack_svg__cls-19{fill:#5c71b3}.slack_svg__cls-25{fill:#231f20}.slack_svg__cls-26{fill:#df1d39}.slack_svg__cls-28{fill:#915620}.slack_svg__cls-37{fill:#222659}.slack_svg__cls-38{fill:#8e9dcf}.slack_svg__cls-42{fill:#5b3415}.slack_svg__cls-43{fill:#454fa1}.slack_svg__cls-52{fill:#fff}.slack_svg__cls-55{fill:#313866}.slack_svg__cls-56{fill:#3eb883}.slack_svg__cls-57{fill:#7dc9a9}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "slack_svg__Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "slack_svg__Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M580.09 370.81L404.47 269.39l105.91-63.21 175.71 101.51z",
  fill: "url(#slack_svg__linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M531 318.5l38 21.92 31.08-18L562 300.51z",
  fill: "url(#slack_svg__linear-gradient-2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M596.2 315l22.62 13.1 14.85-8.65-22.71-13z",
  fill: "url(#slack_svg__linear-gradient-3)"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-4",
  d: "M584.24 301l18.68 3.84-9.78-123-18.25 1.48zm-16.08-115.29l-18.32-.71-4.74 116 18.32.75z"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-5",
  d: "M535.51 103.18c-1 14.5 1 34.15 14.58 43 10 6.37 26.72 11.18 38.42 12.49 7 .78 14.41.43 20.53-3 8.73-4.72 13.45-14.93 13.79-24.8s-3-19.56-7.24-28.47c-6.82-14.32-12.32-28.82-19-43.14-4.81-10.48-12.49-23.23-25.33-24-18.25-1-26.46 26.55-30.39 39.91a142.57 142.57 0 00-5.41 28zm24.8 42.45a1.18 1.18 0 110 2.35 1.18 1.18 0 010-2.35z"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-4",
  d: "M552.54 56.12a19.34 19.34 0 008 15.36 12.2 12.2 0 0010 1.93 17.75 17.75 0 0013.52-17.21c0-9.6-7.07-17.46-15.72-17.46s-15.8 7.68-15.8 17.38z"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-5",
  d: "M586.86 59.08s-27.43-4.36-36.77-11.17c0 0 3.49-15.29 20.26-13 16.24 2.19 16.51 24.19 16.51 24.19z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M530.35 238.28L550.09 84c.44-3 5.68-5 8.73-5 4.89.61 19.48 2.61 19.48 2.61s10.83 1.66 11.61 8.3l25.33 150.73s9.52 25.06-40.44 25.06-44.45-27.42-44.45-27.42z",
  fill: "url(#slack_svg__linear-gradient-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M546.86 109.21c9.34 8.56 19.21 17 30.74 22.27 5.94 2.62 12.31 4.45 18.86 4 .35 0 .7-.09 1-.09l1.92 11.26a11.48 11.48 0 01-7.25 4.28 27.56 27.56 0 01-7.59 0 37.22 37.22 0 01-4-2.27 1.06 1.06 0 00-1.4.18c-3.75-1.66-21-9.87-30.39-15.63a29 29 0 01-4.54-3.15l2.62-20.87z",
  fill: "url(#slack_svg__linear-gradient-5)"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-4",
  d: "M573.58 70.44l-8.64-1.14c.43 10-6.12 9.78-6.12 9.78s.79 6.9 8.65 7.25 10.83-4.63 10.83-4.63c-6.2-1.74-4.72-11.26-4.72-11.26zm6.64-4.37c2.36 4.89 9.34-1.22 7.77-6.46s-6-1.4-6-1.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-8",
  d: "M546 280.72l-.79 10.92s-22 21.83-15 26.28c11.35 7.25 33.27-14.67 33.27-14.67 2.36-4.45.79-19.82.79-19.82-14.09 2.18-18.27-2.71-18.27-2.71zm55.45 4.89l3.75 11.44s20.09 22.71 11.79 25.59-31.26-14.59-31.26-14.59c-2.44-3-2.62-21.74-2.62-21.74 13.27 6 18.34-.7 18.34-.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-9",
  d: "M598.73 292.86a14.36 14.36 0 01-1.74-.17.69.69 0 01-.53-.79.68.68 0 01.79-.52c3.84.78 5.5-1.58 5.59-1.66a.6.6 0 01.87-.18.67.67 0 01.17.87c0 .18-1.65 2.45-5.15 2.45zm1 3.23a16.07 16.07 0 01-1.74-.17.69.69 0 01-.53-.79.68.68 0 01.79-.52c3.84.78 5.5-1.58 5.59-1.66a.6.6 0 01.87-.18.69.69 0 01.18.88 5.92 5.92 0 01-5.16 2.44zm-46.46-7.6a9 9 0 01-5.23-1.74.68.68 0 01-.18-.88.67.67 0 01.87-.17c3.41 2.27 6.38 1.22 6.47 1.13a.64.64 0 01.87.35.65.65 0 01-.35.88 5.83 5.83 0 01-2.45.43zm-.52 3.06a9 9 0 01-5.24-1.75.63.63 0 01.7-1c3.41 2.27 6.37 1.22 6.46 1.13a.65.65 0 01.88.35.64.64 0 01-.35.87 5.58 5.58 0 01-2.45.44z"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-4",
  d: "M572.1 107.73a1.72 1.72 0 00-1.14.35c-1.22.87-.09 4 .44 5a8.55 8.55 0 004.45 3.76 2.88 2.88 0 001.23.26 1 1 0 001-.61c.26-.53-.09-1.22-.35-1.75-1.14-1.83-2.27-3.67-3.5-5.41a3.32 3.32 0 00-.7-.88 1.58 1.58 0 00-1.39-.69z"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-10",
  d: "M581.79 63.36a.47.47 0 00.44-.26c.7-1.4 1.48-2.27 2.27-2.44a1.71 1.71 0 011.22.35.43.43 0 00.61 0 .42.42 0 000-.62 2.69 2.69 0 00-2-.61c-1.13.18-2.09 1.14-3 2.88a.6.6 0 00.18.62.34.34 0 00.28.08z"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-10",
  d: "M584.5 64.76a.44.44 0 00.43-.35 2.68 2.68 0 00-.34-2.36 2.73 2.73 0 00-2.1-1 .44.44 0 000 .88 1.91 1.91 0 011.4.61 1.81 1.81 0 01.17 1.57c-.09.26.09.44.35.52l.09.09z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M547.12 125.19l32 18.51-10.43-43.7-32.13-18.56z",
  fill: "url(#slack_svg__linear-gradient-6)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M570.87 98.73l-2.18 1.27 10.48 43.75 2.18-1.22z",
  fill: "url(#slack_svg__linear-gradient-7)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M570.87 98.73l-32-18.51-2.27 1.22L568.69 100z",
  fill: "url(#slack_svg__linear-gradient-8)"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-4",
  d: "M595.68 148.25a10 10 0 009.6-12.49L594 91.05a7.84 7.84 0 10-15.2 3.84l6.73 26.81-11.09-9.61A7.86 7.86 0 10564.15 124l25.15 21.8a9.14 9.14 0 006.38 2.45z"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-4",
  d: "M576.9 120.13a1.87 1.87 0 001.66-1 2 2 0 00-.7-2.71c-6.11-3.67-11.09-13.45-11.18-13.54a2 2 0 00-2.62-.87 2 2 0 00-.87 2.62c.26.44 5.59 10.92 12.66 15.11a1.7 1.7 0 001 .35z"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-4",
  d: "M570.87 119.69a2 2 0 001.49-.7 2 2 0 00-.26-2.79c-5.59-4.63-10.13-13.63-10.13-13.71a2 2 0 00-3.5 1.74c.18.44 4.89 9.78 11.18 14.94a1.77 1.77 0 001.22.52z"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-4",
  d: "M569.56 124.23a2 2 0 001.49-.7 2 2 0 00-.26-2.79c-5.68-4.72-11.18-14.41-11.18-14.5a2 2 0 00-3.49 1.92c.26.44 5.93 10.48 12.13 15.63a2.56 2.56 0 001.31.44z"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-4",
  d: "M571.57 129.47a2 2 0 001.66-.87 2 2 0 00-.52-2.71c-9.61-6.38-12.93-13.45-13-13.54a2 2 0 00-2.62-1 2 2 0 00-1 2.62c.17.35 3.75 8 14.41 15.11a2.05 2.05 0 001 .35zm-31.26-30.56h.17c.79-.09 2.19-.44 2.28-.44a1.86 1.86 0 001.39-2.36 1.9 1.9 0 00-2.36-1.4 12.83 12.83 0 01-1.83.35 2 2 0 00-1.75 2.19 2.24 2.24 0 002.1 1.66z"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-4",
  d: "M541.18 102a8.59 8.59 0 003.67-1.13 2 2 0 00-2-3.41 4.59 4.59 0 01-1.74.61 2 2 0 00-.27 3.93z"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-4",
  d: "M541.53 105.11a6.56 6.56 0 002.62-.62 2 2 0 001-2.62 2 2 0 00-2.62-1c-.35.17-.87.35-1 .26a2 2 0 00-2.1 1.83 1.91 1.91 0 001.83 2.1.67.67 0 00.35.09z"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-4",
  d: "M542.06 108.08h.43l1.31-.27a2 2 0 10-.87-3.84l-1.31.26a2 2 0 00-1.48 2.36 2 2 0 001.92 1.49z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M321.44 515.43L145.83 414l160.9-92.41 175.71 101.53z",
  fill: "url(#slack_svg__linear-gradient-9)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.18 364.09L0 277.57v46.8a9.24 9.24 0 004.6 8l140.58 81.28a27.44 27.44 0 0027.59 0l139.48-80.82a9.24 9.24 0 004.6-8v-47.26l-144.08 86.52a27.88 27.88 0 01-27.59 0z",
  fill: "url(#slack_svg__linear-gradient-10)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.18 364.09L2.3 281.52a4.65 4.65 0 010-8l141.78-81.83a27.42 27.42 0 0127.58 0l142.89 82.48a4.66 4.66 0 010 8L172.77 364a27.66 27.66 0 01-27.59.09z",
  fill: "url(#slack_svg__linear-gradient-11)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M159 369.61a29 29 0 01-14.71-4L1.38 283.18 3.22 280l142.88 82.44a25.8 25.8 0 0025.75 0l141.78-81.84 1.84 3.22-141.78 81.83a30.15 30.15 0 01-14.69 3.96z",
  fill: "url(#slack_svg__linear-gradient-12)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "slack_svg__cls-8",
  cx: 14.45,
  cy: 313.96,
  rx: 4.78,
  ry: 8.37,
  transform: "rotate(-30.34 14.458 314.018)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M142.42 394.62L53 342.94v-13.51l89.46 51.67z",
  fill: "url(#slack_svg__linear-gradient-13)"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-19",
  d: "M176.17 394.62l130.56-75.4v-6.16l-130.56 75.4zm0-10.12l130.56-75.39V303l-130.56 75.34z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.18 299.73L0 213.3v46.89a9.23 9.23 0 004.6 8l140.58 81.28a27.39 27.39 0 0027.59 0l139.48-80.82a9.23 9.23 0 004.6-8v-47.26l-144.08 86.43a28.1 28.1 0 01-27.59-.09z",
  fill: "url(#slack_svg__linear-gradient-14)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.18 299.73L2.3 217.16a4.65 4.65 0 010-8l141.78-81.83a27.37 27.37 0 0127.58 0l142.89 82.48a4.65 4.65 0 010 8l-141.78 81.83a27.66 27.66 0 01-27.59.09z",
  fill: "url(#slack_svg__linear-gradient-15)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M159 305.25a29 29 0 01-14.71-4L1.38 218.82l1.84-3.22 142.88 82.47a25.75 25.75 0 0025.75 0l141.78-81.83 1.84 3.22-141.78 81.83a30.15 30.15 0 01-14.69 3.96z",
  fill: "url(#slack_svg__linear-gradient-16)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "slack_svg__cls-8",
  cx: 14.45,
  cy: 249.6,
  rx: 4.78,
  ry: 8.37,
  transform: "rotate(-30.7 13.526 247.085)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "slack_svg__cls-8",
  cx: 33.57,
  cy: 260.63,
  rx: 4.78,
  ry: 8.37,
  transform: "rotate(-30.34 33.595 260.668)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "slack_svg__cls-8",
  cx: 33.57,
  cy: 325.32,
  rx: 4.78,
  ry: 8.37,
  transform: "rotate(-30.7 32.227 322.102)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M142.42 330.25L53 278.58v-13.52l89.46 51.68z",
  fill: "url(#slack_svg__linear-gradient-17)"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-19",
  d: "M176.17 330.25l130.56-75.39v-6.16l-130.56 75.39zm0-10.11l130.56-75.4v-6.16L176.17 314z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M159 277.57a23.4 23.4 0 01-11.49-3l-85.45-49.32a13.81 13.81 0 010-23.9l84.32-48.64a22.81 22.81 0 0123 0l85.4 49.29a13.81 13.81 0 010 23.91l-84.31 48.64a23.41 23.41 0 01-11.47 3.02zm-92.34-68.32a4.55 4.55 0 000 7.91l85.42 49.28a13.66 13.66 0 0013.79 0l84.31-48.64a4.54 4.54 0 000-7.9l-85.51-49.29a13.71 13.71 0 00-13.79 0z",
  fill: "#cfd6ec"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-25",
  d: "M254.84 307.94h19v30.25h-19z"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-26",
  d: "M296.77 365.4c8.19-4.69-23-32.64-23-32.64-4.33 5.61-19-.55-19-.55s-3.77 6.71-1.74 11.4c0 0 37.33 25.47 43.67 21.79z"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-9",
  d: "M272.59 338.65c-.09 0-.09 0-.18-.1a.44.44 0 01-.19-.64 5.18 5.18 0 016-2.48.51.51 0 01.37.55.42.42 0 01-.56.28 4.29 4.29 0 00-5 2 .48.48 0 01-.46.37zm3.49 3.31c-.09 0-.09 0-.18-.1a.44.44 0 01-.18-.64 5.17 5.17 0 016-2.48.5.5 0 01.37.55.41.41 0 01-.55.28 4.31 4.31 0 00-5 2 .47.47 0 01-.46.37zm3.59 3.31c-.09 0-.09 0-.18-.1a.44.44 0 01-.19-.64 5.06 5.06 0 016-2.48.51.51 0 01.37.55.42.42 0 01-.56.28 4.29 4.29 0 00-5 2c-.18.27-.28.37-.46.37z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M279.21 261.6c-.64-20-18.57-23.73-33.84-30.81-8.91-4.13-17.83-8.27-26.66-12.41v-17.65h-30.07c-1.1 0-.27 25.83.28 28.32 2.3 10.11 8.83 12.69 17.47 16.64 8.92 4.14 17.74 8.27 26.66 12.32 17.75 8.28 16.19 8.28 16.19 41.65v25.19A35.56 35.56 0 00279.3 322c-.09-17.65.46-42.47-.09-60.4z",
  fill: "url(#slack_svg__linear-gradient-18)"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-25",
  d: "M225.82 321.61h18.94v30.25h-18.94z"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-26",
  d: "M267.75 379.08c8.18-4.69-23-32.64-23-32.64-4.32 5.61-18.94-.55-18.94-.55s-3.77 6.71-1.75 11.4c0 0 37.33 25.47 43.68 21.79z"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-9",
  d: "M243.56 352.32c-.09 0-.09 0-.18-.09a.44.44 0 01-.18-.64 5.17 5.17 0 016-2.49.51.51 0 01.37.55.41.41 0 01-.55.28 4.31 4.31 0 00-5 2 .46.46 0 01-.46.37zm3.5 3.31c-.09 0-.09 0-.19-.09a.45.45 0 01-.18-.64 5.18 5.18 0 016-2.49.51.51 0 01.36.55.41.41 0 01-.55.28 4.29 4.29 0 00-5 2 .47.47 0 01-.46.37zm3.58 3.31c-.09 0-.09 0-.18-.09a.44.44 0 01-.18-.64 5.07 5.07 0 016-2.49.51.51 0 01.37.56.41.41 0 01-.55.27 4.31 4.31 0 00-5 2c-.18.28-.27.37-.46.37z"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-28",
  d: "M190.09 166.49l14.61-9.06 26.84 43.29-14.61 9.06z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M193.27 177.72s15 .64 21.7-13.52c0 0-19.4-19.95-25.29-17.47-10.68 4.6 3.59 30.99 3.59 30.99z",
  fill: "url(#slack_svg__linear-gradient-19)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M193.27 177.72s15 .64 21.7-13.52c0 0-19.4-19.95-25.29-17.47-10.68 4.6 3.59 30.99 3.59 30.99z",
  fill: "url(#slack_svg__linear-gradient-20)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M250.18 275.27c-.64-19.95-18.57-23.72-33.83-30.8-8.92-4.14-17.84-8.28-26.67-12.41V214.4h-30.06c-1.11 0-.28 25.84.27 28.32 2.3 10.12 8.83 12.69 17.47 16.64 8.92 4.14 17.75 8.28 26.67 12.32 17.74 8.28 16.18 8.28 16.18 41.66v25.19a35.58 35.58 0 0030.07-2.85c-.1-17.68.46-42.48-.1-60.41z",
  fill: "url(#slack_svg__linear-gradient-21)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M207 248c.83-.64 1.65-1.19 2.57-1.84l.28-.27c1.29-.92 2.57-1.75 3.86-2.67-8-3.68-16-7.45-23.9-11.12v-17.7h-30.1c-.46 0-.55 4.42-.55 9.75 5.15 2.11 10.11 4.69 15.45 6.44 1.74.55 3.4 1.1 5 1.74a24.18 24.18 0 012.39.83 37.63 37.63 0 017.08 4.14c1 .55 2.12 1 3.13 1.65a63.82 63.82 0 017 5 1.2 1.2 0 011.28-.19c2.43.89 4.27 2.64 6.51 4.24z",
  fill: "url(#slack_svg__linear-gradient-22)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M251.88 233.62l-39.3-20.14v-17.65h-30.07v36.78l34.11 22 41.11-18.48s-4.01-1.78-5.85-2.51z",
  fill: "url(#slack_svg__linear-gradient-23)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M177.18 231.5v-5.24L211.57 247a2.4 2.4 0 002.48 0L264 218.17v4.32a1.42 1.42 0 01-.65 1.11l-49.3 28.4a2.4 2.4 0 01-2.48 0l-33.75-19.4a1.21 1.21 0 01-.64-1.11z",
  fill: "url(#slack_svg__linear-gradient-24)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.94 157s4.78-11.4 21.88-11.4c19.77 0 30.07 64.64 30.07 64.64s-22.62 18.2-50.2 13c-1-.18-8.83-2.3-8.55-3.49 0-.19 6-42.67 6-42.67l.83-20z",
  fill: "url(#slack_svg__linear-gradient-25)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M187.2 208.89a26 26 0 01-7.91-8.19c-3.67-6.25-5.24-14.25-5-21.42a76.15 76.15 0 00-11.13-5.15l-.09 2.94s-6 42.48-6 42.67c-.27 1.1 7.54 3.21 8.55 3.49 13.52 2.57 25.75-.46 34.85-4.23-1.1-.92-2.3-1.84-3.4-2.76a109.87 109.87 0 00-9.84-7.35z",
  fill: "url(#slack_svg__linear-gradient-26)"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-28",
  d: "M175.8 129.9v20.42c0 3.21 3.13 5.7 6.62 5.33a5.36 5.36 0 005.06-5.06V132.3"
}), /*#__PURE__*/React.createElement("circle", {
  className: "slack_svg__cls-28",
  cx: 189.13,
  cy: 128.43,
  r: 18.11
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-37",
  d: "M185.27 125.68s20.14 20 28.87.36c0 0 9.2-6 5.52-15.63a1.62 1.62 0 00-2.48-.73c-2.12 1.74-6.07 4.13-10.12 1.74 0 0 8.37-1.74 3.13-8.82s-50.3-15.45-43.4 22.62c0 0 2.57 15.26 8.37 14.71 0 0 4-19 10.11-14.25z"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-28",
  d: "M181 126.87s-5.33-2.94-6.16 3.59c-.83 6.34 5.24 7.81 7.26 4.87"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-38",
  d: "M263.24 218.45l-50.48 29.15-34.94-20.14a1.22 1.22 0 010-2.12l50.48-29.14 34.94 20.23a1.13 1.13 0 010 2.02z"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-37",
  d: "M188.4 227.92l42.38-24.55 24.37 14.07-42.39 24.45z"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-28",
  d: "M203.94 231.69l-42.39-23.08a11.25 11.25 0 01-5.79-10.39l1.93-30.8 16.27 1-1.56 25.84a2.77 2.77 0 001.38 2.57c6.89 3.77 26.66 14.8 30.06 16s7.18.46 10.76 0c1.29-.18 2.76-.18 3.5.83.91 1.19-.1 2.57-1.2 3.12a12.53 12.53 0 01-1.65.65 12.37 12.37 0 00-4 2c-1.29 1-1.56 2.11-2.3 3.49-1.65 2.85-3.4 5.8-5.05 8.74z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M150 182s10.95 10.3 25.29 4c0 0 4.69-28.32-6.44-31.81S150 182 150 182z",
  fill: "url(#slack_svg__linear-gradient-27)"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-28",
  d: "M209.82 235a1.78 1.78 0 01-1-.28l-10.48-6.07a2 2 0 112-3.49l10.48 6.07a2 2 0 01-1 3.77zm6.25-1.47a1.81 1.81 0 01-1-.28l-10.48-6.07a2 2 0 112-3.49l10.48 6.07a2 2 0 01.74 2.76 1.9 1.9 0 01-1.74 1.01zm4.6-2.21a1.78 1.78 0 01-1-.28L208 224.33a2 2 0 012-3.49l11.68 6.71a2 2 0 01.74 2.76 1.88 1.88 0 01-1.75 1.01zm1.93-3.86a1.81 1.81 0 01-1-.28l-11.68-6.71a2 2 0 112-3.49l11.67 6.71a2 2 0 01-1 3.77z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M264.53 217.8l-51.77 29.89v-48.27l52.41-30.25v47.53a1.38 1.38 0 01-.64 1.1z",
  fill: "url(#slack_svg__linear-gradient-28)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M261.22 167.6l-51.12 29.52a1.27 1.27 0 00-.65 1.1V245a1.39 1.39 0 00.65 1.1l2.66 1.57v-47.52a1.39 1.39 0 01.65-1.1l51.76-29.88-2.66-1.57a1.13 1.13 0 00-1.29 0z",
  fill: "url(#slack_svg__linear-gradient-29)"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-42",
  d: "M180.49 132.85a.44.44 0 01-.46-.46 3.7 3.7 0 00-.46-2.21 1.48 1.48 0 00-1.56-.74.43.43 0 01-.28-.82 2.35 2.35 0 012.67 1.1 4.7 4.7 0 01.55 2.67.44.44 0 01-.46.46z"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-42",
  d: "M177.82 131.93a.64.64 0 01-.36-.19.43.43 0 010-.64 2.83 2.83 0 012.94-.46.44.44 0 01.18.64c-.18.28-.37.37-.64.19a1.84 1.84 0 00-1.93.27.2.2 0 01-.19.19z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "slack_svg__cls-8",
  cx: 256.24,
  cy: 211.15,
  rx: 6.11,
  ry: 3.56,
  transform: "rotate(-59.64 256.244 211.145)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "slack_svg__cls-8",
  cx: 552.9,
  cy: 114.72,
  rx: 2.41,
  ry: 4.21,
  transform: "rotate(-30.35 552.815 114.73)"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-43",
  d: "M267.49 219.14l-.09 138.16a2.74 2.74 0 001.38 2.4l129.2 76a8.31 8.31 0 008.27 0l134.4-80.59a2.74 2.74 0 001.38-2.39v-230a4.64 4.64 0 012.3-4l7.91-4.6a.95.95 0 01.92 1.66l-7.91 4.6a2.73 2.73 0 00-1.38 2.39v230a4.64 4.64 0 01-2.3 4l-134.4 80.6a10.31 10.31 0 01-5 1.28 10 10 0 01-5.06-1.38L268 361.17a4.76 4.76 0 01-2.3-4l.1-138.16"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-43",
  d: "M267.53 357.21l-.09-138.16a6.43 6.43 0 00-4.05-6l-7-2.76a.93.93 0 00-.64 1.75l7 2.76a4.7 4.7 0 012.94 4.32l.09 138.16"
}), /*#__PURE__*/React.createElement("path", {
  d: "M506.82.87a6 6 0 00-6.21 0l-98.71 57a12.22 12.22 0 00-6.09 10.6v192.45a6.12 6.12 0 002.92 5.24c.73.49 11.46 6.34 11.46 6.34l18-26.44-2-6 65.08-37.54a12.23 12.23 0 006.09-10.6v-164l21.81-20.1L506.82.87z",
  fill: "url(#slack_svg__linear-gradient-30)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M407.63 267.26V75a12.21 12.21 0 016.09-10.6l98.71-57a6.1 6.1 0 019.14 5.36v192.35a12.23 12.23 0 01-6.09 10.6l-98.71 57a6.16 6.16 0 01-9.14-5.45z",
  fill: "url(#slack_svg__linear-gradient-31)"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-38",
  d: "M418 79a4.71 4.71 0 012.32-4l86.52-50a2.82 2.82 0 014.27 2.43v173.42a4.7 4.7 0 01-2.32 4l-86.52 50a2.82 2.82 0 01-4.27-2.44z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M405.19 267.26h4.87V75a9.87 9.87 0 014.88-8.53l98.71-57-2.44-4.27-98.71 57a14.92 14.92 0 00-7.31 12.8z",
  fill: "url(#slack_svg__linear-gradient-32)"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-9",
  d: "M429.2 92.63a1.68 1.68 0 01.61-2.44l68.24-39.36a1.71 1.71 0 012.44.61 1.68 1.68 0 01-.61 2.44l-68.25 39.36a3.77 3.77 0 01-1 .24 1.67 1.67 0 01-1.43-.85zm0 14.63a1.68 1.68 0 01.61-2.44l68.24-39.36a1.7 1.7 0 012.44.61 1.67 1.67 0 01-.61 2.43l-68.25 39.36a3.46 3.46 0 01-1 .25 1.69 1.69 0 01-1.43-.85zm0 14.62a1.68 1.68 0 01.61-2.44l68.24-39.36a1.71 1.71 0 012.44.61 1.68 1.68 0 01-.61 2.44l-68.25 39.36a3.77 3.77 0 01-1 .24 1.67 1.67 0 01-1.43-.85zm21.44 2.19a1.68 1.68 0 01.61-2.44l46.8-27a1.71 1.71 0 012.44.61 1.68 1.68 0 01-.61 2.44l-46.8 27.05a3.85 3.85 0 01-1 .25 1.5 1.5 0 01-1.44-.91zM429.2 136.5a1.66 1.66 0 01.61-2.43l14.38-8.29a1.69 1.69 0 012.43.61 1.66 1.66 0 01-.61 2.43l-14.38 8.29a3.85 3.85 0 01-1 .25 1.68 1.68 0 01-1.43-.86zm42.89-10.11a1.68 1.68 0 01.61-2.44l25.35-14.62a1.7 1.7 0 012.44.61 1.67 1.67 0 01-.61 2.43L474.53 127a3.83 3.83 0 01-1 .24 1.69 1.69 0 01-1.44-.85zm-42.89 24.74a1.68 1.68 0 01.61-2.44L463.93 129a1.77 1.77 0 011.83 3l-34.13 19.75a3.77 3.77 0 01-1 .24 1.69 1.69 0 01-1.43-.86zm0 14.62a1.68 1.68 0 01.61-2.44L498.05 124a1.71 1.71 0 012.44.61 1.68 1.68 0 01-.61 2.44l-68.25 39.36a3.77 3.77 0 01-1 .24 1.67 1.67 0 01-1.43-.9zm0 14.62a1.66 1.66 0 01.61-2.43l68.24-39.37a1.71 1.71 0 012.44.61 1.68 1.68 0 01-.61 2.44L431.63 181a3.85 3.85 0 01-1 .25 1.68 1.68 0 01-1.43-.88zm26.81-.85a1.68 1.68 0 01.61-2.44l41.43-23.88a1.7 1.7 0 012.44.61 1.67 1.67 0 01-.61 2.43l-41.44 23.89a3.77 3.77 0 01-1 .24 1.67 1.67 0 01-1.44-.85zm-13.77 7.92a1.68 1.68 0 01.6-2.44l6.34-3.65a1.7 1.7 0 012.44.61 1.67 1.67 0 01-.61 2.43l-6.34 3.66a3.77 3.77 0 01-1 .24 1.47 1.47 0 01-1.43-.85zm-13 7.56a1.68 1.68 0 01.61-2.44l8-4.63a1.78 1.78 0 111.83 3l-8.05 4.63a3.77 3.77 0 01-1 .24 1.69 1.69 0 01-1.43-.8zm63.24-21.94a1.68 1.68 0 01.61-2.44l5-2.92a1.71 1.71 0 012.44.61 1.68 1.68 0 01-.61 2.44l-5 2.92a3.87 3.87 0 01-1 .24 1.49 1.49 0 01-1.48-.85zm-63.28 36.56a1.68 1.68 0 01.61-2.44l55.56-32.05a1.78 1.78 0 011.83 3.05l-55.57 32a3.77 3.77 0 01-1 .24 1.67 1.67 0 01-1.43-.8zm41.31-10.48a1.68 1.68 0 01.61-2.44l26.93-15.6a1.71 1.71 0 012.44.61 1.68 1.68 0 01-.61 2.44l-26.94 15.6a3.77 3.77 0 01-1 .24 1.47 1.47 0 01-1.43-.85zM429.2 223a1.67 1.67 0 01.61-2.43L465 200.24a1.7 1.7 0 012.44.61 1.67 1.67 0 01-.61 2.43l-35.22 20.35a3.46 3.46 0 01-1 .25 1.68 1.68 0 01-1.41-.88z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M517.9 55c.72-4.22-1.07-9.88-1.16-13.2a190.23 190.23 0 01.26-20.16c.45-5.92-.71-13.47-7.63-15.26 2.07 5.56 1.71 7.54 1.71 7.54s-4-7.27-10.42-7.09a15.88 15.88 0 013.59 8s-4.67-3.41-8.53-1.8c8.71 5.12 3.23 11.86 8.8 12.93 2 10.15-3.23 21.29 3 30.9 1.52 2.42 4.84 3.95 7.36 2.69a6 6 0 003-4.58z",
  fill: "url(#slack_svg__linear-gradient-33)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M516.91 70.85l-3.41 18.68-12.12 1.08s3.05 13.65-1.35 18.14-8.08 2.43-12.93 4.4c-1-2.24 2.52-5.12 2.52-5.12a14 14 0 00-5.48 1c-1-2.6 2.51-4.94 2.51-4.94a9.19 9.19 0 00-4.13.36c-.9-4 7.72-4.67 7.72-4.67s-12.39-21-.18-27.3c10.6-5.48 26.85-1.62 26.85-1.62z",
  fill: "url(#slack_svg__linear-gradient-34)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M504.34 85.94c-5-7.54-1.34-19.58-.09-26.58C506.59 46.61 529 44.81 529 51c.18 14.46 8 17.33 9.79 27.75 1.43 8.35-4.22 13.92-10 16.34-8.1 3.51-19.15-.98-24.45-9.15z",
  fill: "url(#slack_svg__linear-gradient-35)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M505 35.47c2.79-8.08-7.54-3.68-8.89-14.73a16.22 16.22 0 00-3.59 11.05c.45 4.94-1.53 8.44.63 12.21 1.88 3.51 6.37 2.52 8.08.72 2.87-3 2.69-6.1 3.77-9.25z",
  fill: "url(#slack_svg__linear-gradient-36)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M501.29 26.94c4.85-5.75 19.49-7.9 29.54 3.41 3.24 3.69-5.74 3-.09 11.23 8.27 12-20.92 22.72-28.46 21-1.71-.45-9.7-12.57-7.37-16.88-2-2.78-2.06-4.94-1.61-6.92.72-2.51 5.92-9.33 8-11.85z",
  fill: "url(#slack_svg__linear-gradient-37)"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-52",
  d: "M492.85 52.62a.28.28 0 00.18-.09l.81-1.07a.09.09 0 00-.09-.09 4.11 4.11 0 01-2.75-1.08h-.09a.09.09 0 00-.09.09c-.09.9 1.17 1.8 2.07 2.24zm2.15.63l-.54-1.7h-.09l-.89 1.25c-.09 0-.09.09 0 .09l1.34.54c.18.09.27 0 .18-.18zm.9.18l1.62-2.06v-.09c0-.18-.18-.18-.27-.18h-.09a9.36 9.36 0 01-1.35.18h-.45c-.09.09-.18.18-.18.27l.54 1.88zm4 .9h.09c.18-.09.27-.27.18-.36l-1.7-2.78h-.09c-.27.45-1.44 1.79-1.89 2.42v.09c-.09.09 0 .27.18.27 1.08.18 2.15.27 3.23.36zm1.17-.18h.18l2.06-3.68v-.09c0-.18-.17-.18-.26-.18a16.8 16.8 0 00-2.25.36l-1.26.27h-.09c-.18.09-.27.27-.18.36l1.8 3zm4.4-.27l-1.71-3.14h-.09L501.92 54v.09c-.09.18.09.27.27.27 1 0 2 0 3.05-.09.18-.12.27-.27.18-.39zm.9 0l1.3-3.88v-.09c0-.18-.18-.27-.36-.27a8.24 8.24 0 00-1.44.09c-.54.09-1 .09-1.44.18h-.09c-.18.09-.27.27-.18.36l2 3.59h.09c0 .09.09 0 .09 0zm3.95-.27h.18c.09-.09.18-.27.09-.36l-2.43-2.78c0-.09-.09 0-.09 0L507 53.79v.09c0 .09.18.18.36.18 1.07-.18 2.06-.27 3-.45zm1-.45c0 .09.09.09 0 0 .09.09.18 0 .09 0l1.25-3.32v-.09c0-.09-.18-.18-.27-.18h-3.68c-.09.09-.18.18-.09.27l2.7 3.32zm4.4-1.43c-.54-.45-1.89-1.62-2.25-2 0-.09-.09 0-.09 0l-1.16 3V53c0 .18.17.18.35.18 1.08-.27 2.16-.63 3.15-1 .12-.09.12-.27-.06-.45zm1.08-2.07c0-.18-.18-.27-.27-.18H516a6.81 6.81 0 01-1.35.09h-.09a.28.28 0 01-.18.09.17.17 0 000 .27l2 1.71h.09a.09.09 0 00.09-.09l.18-1.89zm1.88.9l-1.08-1.17h-.09a.09.09 0 00-.09.09l-.18 1.8c0 .09.09.18.18.09a5.74 5.74 0 001.26-.72zm1.08-.72a3.12 3.12 0 001.17-2v-.24h-.09a2.94 2.94 0 01-.9.89 6.21 6.21 0 01-1.71.63v.09l1 1h.09a2 2 0 00.45-.36z",
  id: "slack_svg__Teeth"
}), /*#__PURE__*/React.createElement("path", {
  d: "M518.26 76.42a14.59 14.59 0 018.71 4 11.09 11.09 0 012.7 4 12 12 0 01-.45 8.09c-1.08 2.69-3.15 4.94-3.5 7.81a22.37 22.37 0 00.8 9.43c1 2.87 3.42 4.31 3.42 7.45 0 1.53-6.38 12-7.55 11.32-3.14-1.89-.63-5.39-.63-5.39a14.15 14.15 0 00-5.29 3.77c-2.07-2.24 0-5.3 0-5.3a10.61 10.61 0 00-5.48 2.16c-1.44-4.4 5.57-7.82 5.57-7.82-5.3-2.06-9.43-4.31-11.32-9.78a34.59 34.59 0 01-.45-20.66c1.08-3.59 3-7.27 6.56-8.44a16.67 16.67 0 016.91-.72z",
  fill: "url(#slack_svg__linear-gradient-38)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M519.61 65.65c1.17-11.59-13.74-6-20.12-9.34-4.58-2.43-6.82-17.31-7.49-23.17S488.9 20 481.71 19.49c3 5.12 3 7.18 3 7.18s-5.3-6.46-11.59-5.12a15.69 15.69 0 015 7.19s-5.21-2.52-8.71-.27c9.43 3.5 5.3 11 11 11.13 1.34 3.51 1 19 6 25.06 6.74 7.81 32 13.56 33.23 1z",
  fill: "url(#slack_svg__linear-gradient-39)"
}), /*#__PURE__*/React.createElement("g", {
  id: "slack_svg__b_w_mascot",
  "data-name": "b+w mascot"
}, /*#__PURE__*/React.createElement("g", {
  id: "slack_svg__Brow_Eyes",
  "data-name": "Brow + Eyes"
}, /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-55",
  d: "M507.13 43.2a10.06 10.06 0 01-2-.18s1.17-.63 2.78-1.62c4.49-2.52 7.1-5.84 9.61-6.11 1.53-.18 2.25 1.89 2.25 1.89a6 6 0 00-2.52 0 14 14 0 00-4.67 2.42"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-56",
  d: "M512.6 39.6a14 14 0 014.49-1.16 6 6 0 01.18 1.79 5 5 0 01-4.67 4.94 5.54 5.54 0 01-5.38-2"
}))), /*#__PURE__*/React.createElement("g", {
  id: "slack_svg__b_w_mascot-2",
  "data-name": "b+w mascot"
}, /*#__PURE__*/React.createElement("path", {
  id: "slack_svg__Brow_Eyes-2",
  "data-name": "Brow + Eyes",
  className: "slack_svg__cls-57",
  d: "M511.26 41.4a9.5 9.5 0 013.32-1.17 4.38 4.38 0 01.09 1.08 2.88 2.88 0 01-2.67 2.87 3.08 3.08 0 01-3.17-1.18c-.09-.09.36-.54 2.43-1.62z"
})), /*#__PURE__*/React.createElement("g", {
  id: "slack_svg__b_w_mascot-3",
  "data-name": "b+w mascot"
}, /*#__PURE__*/React.createElement("g", {
  id: "slack_svg__Brow_Eyes-3",
  "data-name": "Brow + Eyes"
}, /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-55",
  d: "M497.34 42.66a5.57 5.57 0 00-2.79-.81 3.17 3.17 0 00-1.25.54s0-1.62.72-1.8c1.25-.27 3.23 1.53 5.92 2.43 1 .35 2 .53 2.16.62s-.81.27-1.44.54"
}), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-56",
  d: "M500.66 44.09a2.79 2.79 0 01-2.24 2.52c-1.71.27-2.79-1.08-3.33-2.61a7.08 7.08 0 01-.27-1.34 5.35 5.35 0 012.43 0"
}))), /*#__PURE__*/React.createElement("g", {
  id: "slack_svg__b_w_mascot-4",
  "data-name": "b+w mascot"
}, /*#__PURE__*/React.createElement("path", {
  id: "slack_svg__Brow_Eyes-4",
  "data-name": "Brow + Eyes",
  className: "slack_svg__cls-57",
  d: "M498.33 43.73a5.46 5.46 0 00-1.8-.18c0 .18.09.45.09.63a1.68 1.68 0 001.8 1.35 1.74 1.74 0 001.34-1.26 6.92 6.92 0 00-1.43-.54z"
})), /*#__PURE__*/React.createElement("path", {
  className: "slack_svg__cls-52",
  d: "M510.27 41.94c1.26-.54 1.8-.36 1.26-.09s-2.79 1.88-2.79 1.17 1.53-1.08 1.53-1.08zm-11.94 1.88c-.9-.18-1.08.18-.72.27s2.06.9 1.88.36-1.16-.63-1.16-.63z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M545.2 17a1.7 1.7 0 00-.72-.18.74.74 0 00-.53.27A29.26 29.26 0 01530.83 24a13 13 0 00-3.59 1.34 5.9 5.9 0 00-1.88 2.07c-1.71 3.59.45 14.82 6.28 17.69a11.09 11.09 0 005.75-1.44l-1.71-2.87 3.6 1.26a12.34 12.34 0 002.72-5.68l-2.51-1.44 2.78-.8a9.67 9.67 0 000-1.62c-.09-5.12 2.15-9.7 2.69-11.77.09-.44.54-2.24.63-2.6.18-.54.09-1-.36-1.17z",
  fill: "url(#slack_svg__linear-gradient-40)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M528.86 34.13c.45-1.53.81-3.69 5.12-6h.09a27.09 27.09 0 005-3 30.2 30.2 0 006.55-7.09c-.09.36-.54 2.16-.63 2.6-.54 2.07-2.78 6.65-2.69 11.77V34l-2.79.8 2.52 1.44a11.51 11.51 0 01-2.69 5.66l-3.6-1.26 1.71 2.87a10.61 10.61 0 01-5.72 1.49c-.18-.36-.27-.72-.45-1.08-1.34-2.87-3.23-7-2.42-9.78z",
  fill: "url(#slack_svg__linear-gradient-41)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M505.87 26.85c-.54-.27-2.61.54-2.61.54-.44.18-.71.72-.35.9a2.64 2.64 0 002.33-.09c1-.45 1.17-1.17.63-1.35z",
  fill: "url(#slack_svg__linear-gradient-42)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M506.59 29.1c-1.17.36-.18 1.52.54 1.52s1.79-.72 1.52-1.16-1.43-.63-2.06-.36z",
  fill: "url(#slack_svg__linear-gradient-43)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M509.73 25.68c-.9.09-1.71 1.44-1.71 1.89s.72.63 2.25.54 2.69-1.26 2.6-1.71-2.24-.9-3.14-.72z",
  fill: "url(#slack_svg__linear-gradient-44)"
})));

function SvgSlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 686.09 515.43"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/slack.3a08ba82.svg";
export { SvgSlack as ReactComponent };